import { Component, Input } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-quality-score-grid-custom-header',
    templateUrl: './quality-score-grid-custom-header.component.html',
    styleUrl: './quality-score-grid-custom-header.component.scss'
})
export class QualityScoreGridCustomHeaderComponent {

    @Input() moduleManager: ModuleManager;

    public params: IHeaderParams;
    isExpanded = false;

    agInit(params: IHeaderParams): void {
        this.params = params;
        this.updateExpandState();
    }

    toggleGroup(): void {
        const shouldExpand = !this.isExpanded;
        this.params.api.forEachNode((node) => {
            if (node.group) {
                node.setExpanded(shouldExpand);
            }
        });
        this.isExpanded = shouldExpand;
    }

    updateExpandState(): void {
        let allExpanded = true;
        let hasGroupNodes = false;

        this.params.api.forEachNode((node) => {
            if (node.group) {
                hasGroupNodes = true;
                if (!node.expanded) {
                    allExpanded = false;
                }
            }
        });
        this.isExpanded = hasGroupNodes && allExpanded;
    }
}
